
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowColour as ObiLightSnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-colour.js';
 
 
 

 
 export const ObiLightSnowColour = createComponent({
   react: React,
   tagName: 'obi-light-snow-colour',
   elementClass: ObiLightSnowColourElement,
   events: {
     
   }
  });
 
 